import { render } from "./UserBotIndexView.vue?vue&type=template&id=15ac3a4b&scoped=true"
import script from "./UserBotIndexView.vue?vue&type=script&lang=js"
export * from "./UserBotIndexView.vue?vue&type=script&lang=js"

import "./UserBotIndexView.vue?vue&type=style&index=0&id=15ac3a4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ac3a4b"]])

export default __exports__